export default "__VITE_ASSET__B0$9lb5F__"